import { useState } from 'react';

function useForceRefresh() {
  // eslint-disable-next-line no-unused-vars
  const [_state, setState] = useState({});
  return () => setState(() => ({}));
}

export default useForceRefresh;
